//import { COMMON, PublisherTypes } from '@azz-life-streamer/shared';

import { COMMON } from "../const/common.const";
import { PublisherTypes } from "../enums/common.enum";

export class PublisherSelectClass {


  protected readonly PublisherTypes = PublisherTypes;

  private _token: string = '';

  constructor() {

  }

  set token(token: string) {
    this._token = token;
  }

  get token(): string {
    return this._token;
  }

  protected onSelect(option: number): void {
    let url: string = '';
    switch (option) {
      case PublisherTypes.full:
        url = COMMON.urls.publishFull;
        break;
      case PublisherTypes.commentator:
        url = COMMON.urls.publishCommentator;
        break;
    }

    if (url !== '') {
      console.log('[PublisherSelectComponent] onSelect ' + url + '/' + this.token.toLowerCase());
     this.navigateToSection( [url, this.token.toLowerCase()]);
    }
  }

  protected navigateToSection(section: string[]): void {
    // must be overridden
  }
}
